// extracted by mini-css-extract-plugin
module.exports = {"button_container":"CloseButton_button_container__1_3PD","cross":"CloseButton_cross__fzBVL","progress_bar":"CloseButton_progress_bar__2AvUT"};